/* =====================================================
   ui-security-reactive · lifecycle permissions
   What the backend requires to move an entity to a target status
   (ApiCollectionController, TemplateInstanceController, BusinessEventController):
   the domain's base edit permission AND the target-status permission.
   Targets without an entry (e.g. back to DRAFT) need only the base permission.

   Usage (template):
     bm-requires bm-requires-all="{{ $root.lifecyclePermissions('API_COLLECTION', tr.target) }}"
   ===================================================== */
angular.module('bizmetryApp')
  .constant('LIFECYCLE_PERMISSIONS', {
    API_COLLECTION: {
      base: 'EDIT_API_COLLECTION',
      targets: {
        PENDING_REVIEW: 'AC_SUBMIT_FOR_REVIEW',
        APPROVED:       'AC_REVIEW_APPROVE',
        REJECTED:       'AC_REVIEW_REJECT',
        PUBLISHED:      'AC_PUBLISH',
        RETIRED:        'AC_RETIRE'
      }
    },
    TEMPLATE_VERSION: {
      base: 'EDIT_TEMPLATE_VERSION',
      targets: {
        PENDING_REVIEW: 'TV_SUBMIT_FOR_REVIEW',
        REVIEWED:       'TV_REVIEW_APPROVE',
        REJECTED:       'TV_REVIEW_REJECT',
        PUBLISHED:      'TV_PUBLISH',
        RETIRED:        'TV_RETIRE'
      }
    },
    BIZ_EVENT: {
      base: 'UPDATE_BIZ_EVENT',
      targets: {
        PENDING_REVIEW: 'BIZ_EVENT_SUBMIT_FOR_REVIEW',
        APPROVED:       'BIZ_EVENT_APPROVE',
        REJECTED:       'BIZ_EVENT_REJECT',
        PUBLISHED:      'BIZ_EVENT_PUBLISH',
        RETIRED:        'BIZ_EVENT_RETIRE'
      }
    }
  })
  .run(['$rootScope', 'LIFECYCLE_PERMISSIONS', function ($rootScope, LIFECYCLE_PERMISSIONS) {
    // All permissions a transition to `targetStatus` needs (use with bm-requires-all).
    $rootScope.lifecyclePermissions = function (domain, targetStatus) {
      const cfg = LIFECYCLE_PERMISSIONS[domain];
      if (!cfg) return [];
      const target = targetStatus && cfg.targets[targetStatus];
      return target ? [cfg.base, target] : [cfg.base];
    };
  }]);
